import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-fluid formgrid grid" }
const _hoisted_2 = { class: "field col-12 lg:col-6" }
const _hoisted_3 = { class: "field col-12 lg:col-6 text-right" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1)
const _hoisted_5 = {
  key: 0,
  class: "col-12"
}
const _hoisted_6 = {
  key: 1,
  class: "field col-12 text-right"
}
const _hoisted_7 = {
  key: 2,
  class: "col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"])),
    onKeydown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleKeydown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statDpiDelivered.period")), 1),
        _createVNode(_component_Calendar, {
          manualInput: false,
          minDate: new Date('01/01/2020'),
          maxDate: new Date(),
          selectionMode: "range",
          showIcon: true,
          modelValue: _ctx.period,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.period) = $event)),
          yearRange: '2020:2100',
          onDateSelect: _ctx.dataChanged
        }, null, 8, ["minDate", "maxDate", "modelValue", "onDateSelect"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Button, {
          label: _ctx.t('buttons.search'),
          icon: "pi pi-search",
          type: "submit",
          class: "p-button-primary p-uppercase"
        }, null, 8, ["label"])
      ]),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Divider)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults && _ctx.results.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Button, {
              label: _ctx.t('buttons.print'),
              icon: "pi pi-print",
              class: "p-button-primary p-uppercase",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.printReport()))
            }, null, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_DataTable, {
              dataKey: "id",
              responsiveLayout: "scroll",
              showGridlines: "",
              sortField: "dpi",
              sortOrder: 1,
              stripedRows: "",
              value: _ctx.results
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "dpi",
                  sortField: "dpi.name",
                  header: _ctx.t('dpi.name'),
                  sortable: "",
                  style: {"width":"60%"}
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createElementVNode("span", null, _toDisplayString(data[field]?.name ?? "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "size",
                  header: _ctx.t('storedDpi.size'),
                  bodyClass: "text-center",
                  style: {"width":"20%"}
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createElementVNode("span", null, _toDisplayString(data[field] ?? "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "quantity",
                  header: _ctx.t('storedDpi.quantity'),
                  bodyClass: "text-center",
                  style: {"width":"20%"}
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.n(data[field], "number0")), 1)
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}